import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (<div data-testid="page-not-found" />);
  }
}

export default NotFound;
